import { SceneCard, type SceneCardStatus, type SceneCardValues } from '../SceneCard';
import type { PublishDevice } from '../types';

export interface StoriesStepScene {
  sceneOriginId: string;
  sceneInstanceId: string;
}

interface Props {
  scenes: StoriesStepScene[];
  projectInstanceId?: string | null;
  devices: PublishDevice[];
  values: Record<string, SceneCardValues>;
  showErrors: boolean;
  onChange: (sceneOriginId: string, patch: Partial<SceneCardValues>) => void;
  onStatusChange: (sceneOriginId: string, status: SceneCardStatus) => void;
}

export function ProjectStoriesStep({
  scenes,
  projectInstanceId,
  devices,
  values,
  showErrors,
  onChange,
  onStatusChange,
}: Props) {
  return (
    <div className="space-y-3">
      {scenes.map((scene) => (
        <SceneCard
          key={scene.sceneOriginId}
          sceneOriginId={scene.sceneOriginId}
          sceneInstanceId={scene.sceneInstanceId}
          projectInstanceId={projectInstanceId}
          devices={devices}
          values={values[scene.sceneOriginId] ?? { name: '', intro: '' }}
          showErrors={showErrors}
          onChange={(patch) => onChange(scene.sceneOriginId, patch)}
          onStatusChange={(status) => onStatusChange(scene.sceneOriginId, status)}
        />
      ))}
    </div>
  );
}
